/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForCostAnomaly extends models.GovernanceConfigurationBaseForCost {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForCostAnomaly.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForCostAnomaly>): GovernanceConfigurationBaseForCostAnomaly {
        let obj = Object.assign(new GovernanceConfigurationBaseForCostAnomaly(), model);
        GovernanceConfigurationBaseForCostAnomaly.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForCostAnomaly>): GovernanceConfigurationBaseForCostAnomaly {
        if (!model) return null;
        return GovernanceConfigurationBaseForCostAnomaly.newInstance(<GovernanceConfigurationBaseForCostAnomaly> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForCostAnomaly) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForCostAnomaly.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForCostAnomaly): boolean {
        if (models.GovernanceConfigurationBaseForCost.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForCostAnomaly.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether realtime notification enabled or not.
     */
    enable_realtime_notification: boolean;

    /**
     * Specifies whether daily summary notification enabled or not.
     */
    enable_daily_summary_notification: boolean;

}
